import { useTranslation } from 'react-i18next';
import { useOrders } from '@/hooks/useOrders';
import { LiveMapView } from '@/components/tracking/LiveMapView';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { AlertCircle, Map } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';

const LiveMap = () => {
  const { t } = useTranslation();
  const { orders, isLoading } = useOrders();

  // Filter orders (assigned, in_transit, and delivered)
  const activeMissions = orders
    .filter((order) => order.status === 'assigned' || order.status === 'in_transit' || order.status === 'delivered')
    .map((order) => ({
      id: order.id,
      orderNumber: order.order_number,
      pickupAddress: order.pickup_address || `${order.pickup_city}, ${order.pickup_country}`,
      deliveryAddress: order.delivery_address || `${order.delivery_city}, ${order.delivery_country}`,
      pickupLat: order.pickup_lat ? Number(order.pickup_lat) : undefined,
      pickupLng: order.pickup_lng ? Number(order.pickup_lng) : undefined,
      deliveryLat: order.delivery_lat ? Number(order.delivery_lat) : undefined,
      deliveryLng: order.delivery_lng ? Number(order.delivery_lng) : undefined,
      status: order.status,
      createdAt: order.created_at,
    }));

  if (isLoading) {
    return (
      <div className="p-4 md:p-6 space-y-6">
        <div className="flex items-center gap-3 mb-6">
          <Map className="h-8 w-8 text-secondary" />
          <div>
            <h1 className="text-3xl font-semibold text-secondary font-heading">
              {t('nav.liveMap')}
            </h1>
            <p className="text-sm text-muted-foreground">{t('liveMap.description')}</p>
          </div>
        </div>
        <Skeleton className="w-full h-[calc(100vh-12rem)] rounded-xl" />
      </div>
    );
  }

  return (
    <div className="p-4 md:p-6 space-y-6">
      <div className="flex items-center gap-3 mb-6">
        <Map className="h-8 w-8 text-secondary" />
        <div>
          <h1 className="text-3xl font-semibold text-secondary font-heading">
            {t('nav.liveMap')}
          </h1>
          <p className="text-sm text-muted-foreground">{t('liveMap.description')}</p>
        </div>
      </div>

      {activeMissions.length === 0 ? (
        <div className="bg-[#EBF4F8] rounded-xl p-8">
          <Alert>
            <AlertCircle className="h-4 w-4" />
            <AlertDescription>
              {t('liveMap.noActiveMissions')}
            </AlertDescription>
          </Alert>
        </div>
      ) : (
        <LiveMapView missions={activeMissions} />
      )}
    </div>
  );
};

export default LiveMap;
